<template>
    <div class="container">
        <section id="us-one" :class="['section', 'column-desing']">
            <h1 class="title">Diseñamos soluciones que desafían lo posible y resuelven lo urgente.</h1>
            <img src="../assets/principalUS.svg" alt="Equipo de Selk">
        </section>
        <section id="us-two" :class="['section', 'column-desing']">
            <div>
                <h2 class="title">Nuestra Historia</h2>
                <p class="text">Selk nace de una idea simple y poderosa: unir el conocimiento y la visión de un grupo de ingenieros decididos a hacer las cosas de otra manera. Más que una empresa, construimos una plataforma de soluciones que rompe con lo convencional. <br>
                <br>
                Por eso integramos dos especialidades bajo un mismo propósito: el desarrollo de aplicativos web y la automatización empresarial, y el diseño y fabricación de piezas mediante impresión 3D. Dos pilares, una sola misión: generar valor a través de la innovación, la eficiencia y la excelencia técnica.</p>
            </div>
            <img src="../assets/storySelk.svg" alt="La historia de Selk">
        </section>
        <section id="us-three" :class="['section', 'row-desing']">
            <img src="../assets/misionSelk.svg" alt="Misión de Selk">
            <div>
                <h2 class="subtitle">Misión</h2>
               <p class="text">Transformar las ideas de nuestros clientes en sistemas que automatizan y en piezas que se fabrican: soluciones eficientes, sostenibles y de alto impacto. Lo hacemos con tecnología de vanguardia, metodologías ágiles y un equipo comprometido con la calidad y con resultados medibles que perduren en el tiempo.</p>
            </div>
        </section>
        <section id="us-four" :class="['section', 'row-desing']">
            <div>
                <h2 class="subtitle">Visión</h2>
                <p class="text">Ser un referente en el desarrollo de software empresarial y en la manufactura digital mediante impresión 3D, reconocidos por nuestra innovación constante, nuestro compromiso con la sostenibilidad y el valor real que generamos para clientes, colaboradores y la sociedad.</p>
            </div>
            <img src="../assets/upSelk.svg" alt="Visión de Selk">
        </section>
        <section id="us-five" :class="['section']">
            <div>
                <h2 class="title">Nuestros Valores</h2>
                <p class="text">
                    No basta con hacer las cosas bien, hay que hacerlas con propósito, con audacia y con visión. Nuestros valores nos guían en cada decisión, en cada proyecto y en cada desafío que enfrentamos.</p>
            </div>
            <div>
                <div>
                    <img src="../assets/iconOne.svg" alt="Disrupción">
                    <h3 class="subtitle">Disrupción</h3>
                    <p class="text">No seguimos tendencias, las creamos. Pensamos diferente, desafiamos lo establecido y buscamos soluciones que rompan esquemas para transformar problemas complejos en avances significativos.</p>
                </div>
                <div>
                    <img src="../assets/iconFour.svg" alt="Colaboración">
                    <h3 class="subtitle">Colaboración</h3>
                    <p class="text">Creemos en el poder de los equipos diversos, integrados y comprometidos. Nuestra fuerza está en sumar talentos, conocimientos y perspectivas para construir soluciones integrales. </p>
                </div>
                <div>
                    <img src="../assets/iconFive.svg" alt="Visión Global">
                    <h3 class="subtitle">Visión Global</h3>
                    <p class="text">Nuestras soluciones están diseñadas para trascender fronteras, generar impacto sostenible y responder a los desafíos del mundo actual. Buscamos ser referentes internacionales, sin perder nuestras raíces ni nuestros valores.</p>
                </div>
                <div>
                    <img src="../assets/iconTwo.svg" alt="Integridad">
                    <h3 class="subtitle">Integridad</h3>
                    <p class="text">Actuamos con ética, transparencia y coherencia. Construimos relaciones de confianza porque creemos que la forma en que se logran los resultados es tan importante como los resultados mismos.</p>
                </div>
                <div>
                    <img src="../assets/iconSix.svg" alt="Enfoque en el cliente">
                    <h3 class="subtitle">Enfoque en el cliente</h3>
                    <p class="text">Escuchamos, entendemos y actuamos. Cada proyecto comienza con una necesidad y se convierte en una experiencia diseñada para superar expectativas.</p>
                </div>
                <div>
                    <img src="../assets/iconSeven.svg" alt="Sostenibilidad">
                    <h3 class="subtitle">Sostenibilidad</h3>
                    <p class="text">El progreso solo es real si es responsable. Integramos prácticas sostenibles en cada etapa del proceso, cuidando el entorno, optimizando recursos y apostando por soluciones que generen valor a largo plazo para las personas y el planeta.</p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'UsPage',
}
</script>

<style scoped>
#us-one h1 {
    text-align: center;
    margin: 3vw 0 5vw 0;
    width: 80%;
}
#us-two h1{
    text-align: center;
}
#us-four > div > h1 {
    text-align: right;
}
#us-five {
    display: flex;
    flex-direction: column;
    align-items: center;
}
#us-five .subtitle {
    font-size: 30px;
    margin-bottom: 0;
}
#us-five > div:first-of-type{
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 70%;
    margin: 0 0 2vw 0;
}
#us-five > div:nth-of-type(2) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
}
#us-five > div > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 30%;
    margin: 0 auto 2vw auto; 
}
#us-five > div > div > img {
    height: 10%;
    width: auto;
}

@media (max-width: 800px){
    #us-one img{
        content: url(../assets/principalUS_Movile.svg);
        width: 120%;
        height: auto;
    }
    #us-two img, #us-three img, #us-four img {
        width: 100%;
    }
    #us-three, #us-four {
        flex-direction: column;
        align-content: center;
    }
    #us-five > div:nth-of-type(2) {
    flex-direction: column;
    width: 90%;
    }

    #us-five > div > div {
        width: auto;
    }
}

</style>    